import styled from 'styled-components';

export const StyledConfirmedAppointmentsChart = styled.div`
   height: 138px;
   width: 100%;
   margin-top: 12px;
`;
StyledConfirmedAppointmentsChart.displayName = 'StyledConfirmedAppointmentsChart';
